module.exports = __webpack_public_path__ + "static/media/AxaInsuranceLogo_110.a7c36478.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/AxaInsuranceLogo_110.png
// module id = 2412
// module chunks = 0